import { Address, AddressFromFinder, AddressKeys } from "../types";

export const englishOnlyRegX = RegExp("[^\\\u0000-\\\u007F]+");

export const isNumericRegX = RegExp('^[0-9]$');

export const getAddressDetailsEnglish = (values: Address): string => {


    const firstKeyValue: AddressKeys = Object.entries(values)[0][0] as AddressKeys

    let isArabicText: boolean = englishOnlyRegX.test(values[firstKeyValue]!) || englishOnlyRegX.test(values["StreetName"]!) || false;

    const addressDetailsEnglish: string = Object.entries(values)?.map((entry: any) => {

        let key = entry[0]
        let value = entry[1]
        if (!value) {
            return "";
        }
        let isNumericValue = isNumericRegX.test(value) || false;

        if (!isNumericValue) {
            isArabicText = englishOnlyRegX.test(key) || isArabicText;
        }


        if (isArabicText) {
            // if (isNumericValue)
            // value = englishToArabicNumbers(value).split("").reverse().join()
            return (`${addressKeyTranslation["ar"]![key]}: ${value}`);
        } else {
            return (`${addressKeyTranslation["en"]![key]}: ${value}`);
        }


    }).join(" - ")
    return addressDetailsEnglish

}


export const addressKeyTranslation: any = {
    "en": {
        "Area": "Area",
        "BlockNumber": "Block Number",
        "BuildingNumber": "Building Number",
        "FloorNumber": "Floor Number",
        "Governerate": "Governerate",
        "PaciBuildingNumber": "PaciBuildingNumber",
        "StreetName": "Street Name",
        "UnitNumber": "",
        "UnitType": "",
    },
    "ar": {
        "Area": "المنطقة",
        "BlockNumber": "القطعة",
        "BuildingNumber": "رقم المبنى",
        "FloorNumber": "الطابق",
        "Governerate": "المحافظة",
        "PaciBuildingNumber": "رفم المبنى الإلكتروني",
        "StreetName": "اسم الشارع",
        "UnitNumber": "رقم الوحدة",
        "UnitType": "نوع الوحدة",
    }
};

/**
 * One-line English address from a Kuwait Finder lookup, e.g. "Block:4, St:443, H:15, Ishbilya, Kuwait".
 * Falls back to Finder's own DetailsEnglish when the parts are missing. Empty string when there is no address.
 */
export const formatFinderAddress = (finderAddress?: AddressFromFinder | null): string => {
    if (!finderAddress) return "";
    const parts: string[] = [];
    if (finderAddress.BlockEnglish) parts.push("Block:" + finderAddress.BlockEnglish);
    if (finderAddress.StreetEnglish) parts.push("St:" + finderAddress.StreetEnglish.replace("St ", ""));
    if (finderAddress.HouseEnglish) parts.push("H:" + finderAddress.HouseEnglish);
    if (finderAddress.NeighborhoodEnglish) parts.push(finderAddress.NeighborhoodEnglish);
    if (parts.length === 0) return finderAddress.DetailsEnglish || "";
    parts.push("Kuwait");
    return parts.join(", ");
};
